import { useSelector } from 'react-redux';

import { AEMContentProvider, AemFeature, createAemUrl } from '@app/components/AdobeExperienceFragments';
import { selectConfig, selectLocale, selectUserInfo } from '@app/redux';

export const UsageInfoAlert = ({ aemFeature }: { aemFeature: AemFeature }) => {
  const { aemBaseUrl } = useSelector(selectConfig);

  const {
    locale: { userLocale },
  } = useSelector(selectLocale);

  const {
    userInfo: { accountType },
  } = useSelector(selectUserInfo);

  return (
    <AEMContentProvider
      src={createAemUrl({
        baseUrl: aemBaseUrl,
        locale: userLocale,
        //pass the data color to determine the feature
        feature: aemFeature,
        accountType,
      })}
    />
  );
};
